/**
 * workspace模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const workspace = {
  // 根据AccountId查询workspace列表
  queryWorkspaceByAccountId(params) {
    return $http.post(`${global.API_URL}/sme/workspace/queryWorkspaceByAccountId`, params);
  },
  // 根据组查询Workspace
  queryWorkspacesByGroupId(params) {
    return $http.post(`${global.API_URL}/sme/workspace/queryWorkspacesByGroupId`,params);
  },
  // 根据私有ip查询Workspace和定时任务
  queryWorkspacesTaskByPrivateIP(params) {
    return $http.post(`${global.API_URL}/sme/workspace/queryWorkspacesTaskByPrivateIP`,params);
  }
}

export default workspace;



// WEBPACK FOOTER //
// ./src/api/workspace.js